/**
 * Expense Constants
 * Centralized constants for Expense components
 */

export const EXPENSE_STATUS = {
  APPROVED: "approved",
  REJECTED: "rejected",
  PENDING: "pending",
};

export const EXPENSE_STATUS_LIST = [
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "pending", label: "Pending" },
];

export const USER_ROLES = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  USER: 3,
  PROJECT_MANAGER: 6,
  TEAM_MANAGER: 7,
};

export const ALLOWED_FILE_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "msword",
  "xls",
  "xlsx",
  "csv",
  "jpeg",
  "jpg",
  "png",
  "gif",
];

export const MAX_FILE_COUNT = 10;

export const MODAL_STYLES = {
  CREATE_EXPENSE: {
    content: {
      height: "41%",
      width: "30%",
      position: "fixed",
      top: "50%",
      left: "50%",
      parent: document.querySelector(".admin-outer.time.tracker"),
    },
  },
  FILTER_MODAL: {
    content: {
      height: "auto",
      maxHeight: "85vh",
      width: "50%",
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "10px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#fff",
      padding: "20px",
      overflow: "auto",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 99999,
    },
  },
  CONFIRMATION_MODAL: {
    content: {
      height: "41%",
      width: "30%",
      position: "fixed",
      top: "36%",
      left: "50%",
      parent: document.querySelector(".admin-outer.time.tracker"),
    },
  },
};
